import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvelopeResponse } from 'src/app/shared/models/envelope-response';
import { SearchTradesByNameAndEmailResult } from 'src/app/shared/models/search-trades-by-name-and-email-result.model';
import { BaseService } from '../base/base.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TradeSearchService extends BaseService {
  private readonly _urlPrefix = `${environment.tradeMgmt.urlPrefix}/tradee`;
  constructor(http: HttpClient) {
    super(http);
  }

  searchTradesByNameAndEmail(FractionOfTrade: string) {
    return this.get<SearchTradesByNameAndEmailResult[]>(
      this._urlPrefix + '/search?searchTerm=' + FractionOfTrade
    );
  }
}
